module.exports = __webpack_public_path__ + "img/room-3.20d0cc59.jpg";